import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from "../../util/common";
import {reportYear} from "../../util/util";

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {
    report_date: Array,
    oaids: Array,
    report_type: String,
    selectEvent: Boolean,
    industry: String,
    rating: String,
  },
  data: () => {
    return {
      data: [],
      tableColumn: [],
      loading: false,
      exportConfig: {},
      gics: null,
      color: {
        'AAA': '#6ebf7e',
        'AA': '#82d192',
        'A': '#a4dcaf',
        'BBB': '#f0a17d',
        'BB': '#ed8454',
        'B': '#e77743',
        'CCC': '#e56f6f',
        'CC': '#d45e5e',
        'C': '#CC3E3E',
      },
    }
  },
  methods: {
    setAllTreeExpand()
    {
      let self = this
      setTimeout( function(){self.$refs.xTree.setAllTreeExpand(true)}, 200 )
    },
    cellClickEvent({column, columnIndex}) {
      if(column.level === 1 && columnIndex > 1){
        const { href } = this.$router.resolve({path:  '/entity/'+column.title+'/home'})
      window.open(href, '_blank')
      }
    },
    mergeHeader() {
      let tabs = []
      for (let i = 0; i < this.tableColumn.length; i++) {
        let col1 = this.tableColumn[i]
        if (this.tableColumn.length === i + 1) {
          tabs.push(col1)
        } else {
          let col2 = this.tableColumn[i + 1]
          if (col1['field'].replace('_rating', '_score') === col2['field']) {
            tabs.push({
              'title': col1['title'],
              'children': [
                {'title': '评级', 'field': col1['field']},
                {'title': '得分', 'field': col2['field']},
              ]
            })
            i++
          } else {
            tabs.push(col1)
          }
        }
      }
      this.tableColumn = tabs
    },
    colspanMethod(a) {
      if (a.$rowIndex < 3 && a.level === 0) {
        if (a.$columnIndex > 1 && a.$columnIndex % 2 === 0) {
          return {rowspan: 1, colspan: 2}
        } else if (a.$columnIndex > 1 && a.$columnIndex % 2 === 1) {
          return {rowspan: 0, colspan: 0}
        }
      }
    },
    headerCell({column}) {
      if (!column.property || column.property.endsWith("_rating") || column.property.endsWith("_score")) {
        return {
          'text-align': 'center',
        }
      }
    },
    cellStyle({row, column}) {
      let rating = row[column.property]
      if (rating in this.color) {
        return {
          'backgroundColor': this.color[rating],
          'text-align': 'center',
          'color': 'white'
        }
      } else if (column.property.endsWith("_score")) {
        return {
          'backgroundColor': 'white',
          'text-align': 'center'
        }
      } else if (column.property.endsWith("_rating")) {
        return {
          'backgroundColor': 'white',
          'text-align': 'center'

        }
      } else {
        return {
          'backgroundColor': 'white',

        }
      }
    },

    openDataExport() {
      let s = "ESG-rating-score-"
      this.$refs.xTree.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    getGics() {
      let self = this
      reportYear.gics().then(result => {
        self.gics = result
      })
    },
    trans_data(data) {
      for (let i in data) {
        let item = data[i]
        for (let key in item) {
          if (item[key] in this.gics && item['id'] === 'gics') {
            item[key] = this.gics[item[key]][this.$i18n.locale] + "-" + item[key]
          }
        }
      }
      return data
    },
    getESGData() {
      let self = this
      self.loading = true
      self.data = null
      self.tableColumn = []
      let params = new Map()
      params.set("lang", this.$i18n.locale)
      if (self.report_date) {
        params.set("report_date", self.report_date)
      }
      if (self.oaids && self.oaids.length > 0) {
        let promises = []
        let dataList = []
        let columnList = []
        for (let i in self.oaids) {
          let oaid = self.oaids[i]
          params.set("oaid", oaid)
          let promise1 = httpManager("esg_entity_rating_score", params, null, null, null)
            .then(response => {
              dataList[i] = response.data.data
              columnList[i] = response.data.columns
              self.loading = false
            })
            .catch(error => {
              console.log(error)
              self.loading = false
            })
          promises.push(promise1)
        }
        self.data = []
        self.tableColumn = []
        Promise.all(promises).then(function (values) {
          self.data = XEUtils.toArrayTree(self.trans_data(self.mergeDataList(dataList)))
          self.tableColumn = self.mergeColumnList(columnList)
          self.mergeHeader()
          self.setAllTreeExpand()
          self.loading = false
          self.setAllTreeExpand()
        });
      } else if (self.industry) {
        params.set("industry", self.industry)
        params.set("rating", self.rating)
        httpManager("esg_entity_rating_score", params, null, null, null)
          .then(response => {
            self.data = XEUtils.toArrayTree(self.trans_data(response.data.data))
            self.tableColumn = response.data.columns
            self.mergeHeader()
            self.setAllTreeExpand()
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      } else {
        self.loading = false
      }
    },
    mergeDataList(dataList) {
      let dataDict = {}
      for (let i in dataList) {
        let datal = dataList[i]
        for (let j in datal) {
          let id = datal[j].id
          if (id in dataDict) {
            for (let key in datal[j]) {
              dataDict[id][key] = datal[j][key]
            }
          } else {
            dataDict[id] = datal[j]
          }
        }
      }
      let re = []
      for (let key in dataDict) {
        re.push(dataDict[key])
      }
      return re
    },
    mergeColumnList(columnList) {
      let columnDict = {}
      for (let i in columnList) {
        let columnl = columnList[i]
        for (let j in columnl) {
          let field = columnl[j].field
          if (field in columnDict) {
          } else {
            columnDict[field] = columnl[j]
          }
        }
      }
      let re = []
      for (let key in columnDict) {
        re.push(columnDict[key])
      }
      return re
    },
  },
  mounted() {
    this.getGics()
    this.getESGData()
  },
  watch: {
    selectEvent: function () {
      this.getESGData()
    },
  },
  created() {
  }
}
Vue.component("esg-rating-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_rating_table.js